/**
 * PreMatchStats (PMS) locale bundles only (`PreMatchStats.*` keys).
 * JSON under `files/pms/` is updated by `npm run fetch-translations` (CDN); see `fetch-translations.cjs`.
 */

import pms_en_GB from './files/pms/en_GB.json';
import pms_en_GB_long from './files/pms/en_GB_long.json';
import pms_en_IE from './files/pms/en_IE.json';
import pms_et_EE from './files/pms/et_EE.json';
import pms_ro_RO from './files/pms/ro_RO.json';

export const pmsLocale = {
  en_GB: pms_en_GB,
  en_GB_long: pms_en_GB_long,
  en_IE: pms_en_IE,
  et_EE: pms_et_EE,
  ro_RO: pms_ro_RO,
};
